import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaDocumentosCfdiItem', {
    template: template,
    controller: NominasNominaDocumentosCfdiItemComponent,
    bindings: {
      data: '<',
    },
  })

function NominasNominaDocumentosCfdiItemComponent() {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.generar = generar

  function $onInit() {
    $ctrl.configurando = false
    $ctrl.generando = null
    $ctrl.error = validar()
  }

  function generar(data) {
    $ctrl.configurando = false
    $ctrl.generando = data
  }

  function validar() {
    if (!$ctrl.data.logo)
      return 'No se ha especificado el logotipo de la empresa pagadora'

    return null
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/cfdi/item/component.js